import React from 'react'
import appstore from "../../assets/layout/Appstore.png"
import playstore from "../../assets/layout/playstore.png"
const Banner = () => {
    return (
        <div className="banner">
            <div className="app-download-section">
                <h1 className="color-white">Book Ride, Pickup & Drop Anything Across Chennai, Coimbatore, Neyveli, Bangalore & Hyderabad.</h1>
                <p className="color-white m-t-20">Instant delivery service with unmatched convenience to get anything across your city packed up and delivered at your doorstep.</p>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4 p-0">
                            <a href="https://play.google.com/store/apps/details?id=in.ouja.user">
                                <img className="applinkimg" src={playstore} alt="" />
                            </a>
                        </div>
                        <div className="col-md-4 p-0">
                            <div>
                                <img className="applinkimg" src={appstore} alt="" />
                            </div>
                        </div>
                        <div className="col-md-4">
                        </div>
                        <div className="col-md-8"><p className="color-white text-center">Available on Android and iOS
(Coming Soon)</p></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner
